export default __webpack_public_path__ + "static/media/header.325dbc49.jpg";